import PoiIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/landmark';
import { BpkIconMarker } from '@skyscanner/backpack-web/bpk-component-map';

import iconMap from '../PoiIconMap';

import keyFactory from '@shared/utils-frontend/key-factory';

const getPoiIcon = ({ type }: PoiMarkerShape) => {
  if (type && iconMap[type]) {
    return iconMap[type].sm;
  }

  return PoiIconSm;
};

type PoiMarkerShape = {
  latitude: number;
  longitude: number;
  type: string;
  name?: string;
};

type Props = {
  poi: PoiMarkerShape;
  selected?: boolean;
  onClick?: Function;
  className?: string;
  buttonProps?: {
    testId?: string;
  };
};

const PoiMarker = ({ buttonProps, onClick, poi, selected, ...rest }: Props) => {
  const { latitude, longitude, name } = poi;
  const Icon = getPoiIcon(poi);

  const position = {
    latitude,
    longitude,
  };

  const onMarkerClick = onClick ? (e: MouseEvent) => onClick(poi, e) : null;

  return (
    <BpkIconMarker
      key={keyFactory.next()}
      buttonProps={{ ...buttonProps, title: name }}
      icon={<Icon />}
      position={position}
      onClick={onMarkerClick}
      selected={selected}
      {...rest}
    />
  );
};

export default PoiMarker;
